import styled from "styled-components";
import {MdKeyboardArrowRight, MdArrowForward} from 'react-icons/md';

export const HeroContainer = styled.div`
	background: #0c0c0c;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 30px;
	height: 800px;
	position: relative;
	z-index:1;

	:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: linear-gradient(
			180deg,
			rgba(0,0,0,0.2) 0%,
			rgba(0,0,0,0.6) 100%
			),
			linear-gradient(180deg, rgba(0,0,0,0.2) 0%, transparent 100%);
		z-index:2;
	}
	
`

export const HeroBg = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
`

export const VideoBg = styled.video`
	width: 100%;
	height: 100%;
	-o-object-fit:cover;
	object-fit: cover;
	background: #232a34;
`

export const HeroContent =styled.div`
	z-index: 3;
	max-width: 1200px;
	position: absolute;
	padding: 8px 36px;
  left: 20%;
  top: 15%;
	display: flex;
	flex-direction: column;
  @media screen and (max-width: 768px) {
    right: 16%;
    bottom: 25%;
	}
  @media screen and (max-width: 480px) {
    right: 0%;
    bottom: 0%;
    left: 0%;
	}
`
export const AnotherHeroContent =styled.div`
	z-index: 3;
  width: 30%;
	max-width: 1200px;
	position: absolute;
	padding: 8px 24px;
  left: 20%;
  top: 50%;
	display: inline-block;
	flex-direction: column;
	align-items: center;
  @media screen and (max-width: 768px) {
    right: 16%;
    bottom: 15%;
	}
  @media screen and (max-width: 500px) {
    left: 0%;
    width: -webkit-fill-available;
    bottom: 15%;
    text-align:center;
	}
`
export const HeroH1 =styled.h1`
	color: #fff;
  font: normal normal bold 55px "Spoqa Han Sans Neo";
	
	@media screen and (max-width: 768px) {
	  font: normal normal bold 55px "Spoqa Han Sans Neo";

	}

	@media screen and (max-width: 480px) {
	  font: normal normal bold 40px "Spoqa Han Sans Neo";

	}
`

export const HeroP = styled.p`
	margin-top: 24px;
  font: normal normal 300 24px "Spoqa Han Sans Neo";
	color: #fff;
  padding-left: 2px;
	max-width: 600px;
	
	@media screen and (max-width: 768px) {
    font: normal normal 300 24px "Spoqa Han Sans Neo";
	}

	@media screen and (max-width: 480px) {
    font: normal normal 300 24px "Spoqa Han Sans Neo";
		
	}
`

export const HeroBtnWrapper = styled.div`
	margin-top: 32px;
	display: inline-block;
	flex-direction: column;
	align-items: center;
  @media screen and (max-width: 768px) {
    display: table-cell;
	}

	@media screen and (max-width: 480px) {
    display: grid;
		
	}
`

export const ArrowForward = styled(MdArrowForward)`
	margin-left: 8px;
	font-size: 20px;
`
export const ArrowRight = styled(MdKeyboardArrowRight)`
	margin-left: 8px;
	font-size: 20px;
`